export default __webpack_public_path__ + "static/compartir_polizas-7fe39344b8176a981cfca260be325b46.mp4";